import styled from '@emotion/styled'

export const HeaderRow = styled.div({
  marginBottom: 20
})